define('presentation/settings/liveReceptionistScripts/viewModels/liveReceptionistScriptFindMeTabViewModel',[
        'businessServices/authentication/sessionAccountInfo',
        'common/promises/promiseFactory',
        'common/storage/commonState',
        'businessServices/router/router',
        'settings/navigationConfiguration',
        'presentation/common/actionModal/viewModels/actionModalViewModel',
        'presentation/common/actionModal/viewModels/deleteActionViewModel',
        'presentation/settings/schedules/viewModels/scheduleCommonFunctions',
        'presentation/common/warningModal/viewModels/integrityWarningModalViewModel',
        'presentation/settings/liveReceptionistScripts/facades/liveReceptionistScriptFindMeTabFacade'
    ],
    function () {
        return function () {
            const self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const ActionModalViewModelConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
            const DeleteActionViewModelConstructor = require('presentation/common/actionModal/viewModels/deleteActionViewModel');
            const IntegrityWarningModalViewModelConstructor = require('presentation/common/warningModal/viewModels/integrityWarningModalViewModel');

            const _commonState = require('common/storage/commonState');
            const _navigationConfiguration = require('settings/navigationConfiguration');
            const _router = require('businessServices/router/router');
            const _i18n = require('i18next');
            const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');
            const _scheduleCommonFunctions = require('presentation/settings/schedules/viewModels/scheduleCommonFunctions');

            let _promiseFactory = new PromiseFactoryConstructor();
            let _facade = null;
            const _totalQuarterHours = 96;
            const _deleteResponse = "yes";

            class GridCell {
                constructor() {
                    this.inRange = ko.observable();
                    this.rangeColor = ko.pureComputed(() => {
                        const currentRange = this.inRange();
                        if (currentRange > 0) {
                            return `range-background__sequence-${currentRange}`;
                        } else {
                            return "range-background__sequence-all-other";
                        }
                    });
                }
            }

            const _emptyGridCellsForDay = () => Array.from(new Array(_totalQuarterHours), () => new GridCell());

            const _rangeIndicatorClassNumber = (segmentsCount, segmentSequence) => {
                const classNumbers = [0,1,3,6];
                if (segmentsCount < 4) {
                    return classNumbers[segmentSequence];
                } else {
                    return segmentSequence;
                }
            };

            const _setScheduleGridRanges = (schedule, segments) => {
                const dayGrids = [
                    schedule.sundayGridCells,
                    schedule.mondayGridCells,
                    schedule.tuesdayGridCells,
                    schedule.wednesdayGridCells,
                    schedule.thursdayGridCells,
                    schedule.fridayGridCells,
                    schedule.saturdayGridCells,
                ];
                dayGrids.forEach(dayGrid => dayGrid.forEach(dayGridCell => dayGridCell.inRange(0)));

                segments.forEach(segment => {
                    let rangeStartCell = _scheduleCommonFunctions.getGridCell(segment.startHour(), segment.startMinute());
                    let rangeEndCell = _scheduleCommonFunctions.getGridCell(segment.endHour(), segment.endMinute()) - 1;
                    let rangeNumber = _rangeIndicatorClassNumber(schedule.segments().length, segment.sequence());

                    [
                        {isForDay: segment.isForSunday(), dayGridCells: schedule.sundayGridCells},
                        {isForDay: segment.isForMonday(), dayGridCells: schedule.mondayGridCells},
                        {isForDay: segment.isForTuesday(), dayGridCells: schedule.tuesdayGridCells},
                        {isForDay: segment.isForWednesday(), dayGridCells: schedule.wednesdayGridCells},
                        {isForDay: segment.isForThursday(), dayGridCells: schedule.thursdayGridCells},
                        {isForDay: segment.isForFriday(), dayGridCells: schedule.fridayGridCells},
                        {isForDay: segment.isForSaturday(), dayGridCells: schedule.saturdayGridCells}
                    ]
                        .forEach(({isForDay, dayGridCells}) => {
                            if (isForDay) {
                                for (let i = rangeStartCell; i <= rangeEndCell; i++) {
                                    dayGridCells[i].inRange(rangeNumber);
                                }
                            }
                        });
                });
            };

            const _showIntegrityWarningsPrompt = (scheduleId, integrityWarningPresentationObjects) => {
                _buildIntegrityWarningsModal(scheduleId);
                self.integrityWarningModal.addIntegrityWarnings(integrityWarningPresentationObjects);
                self.integrityWarningModal.showModal();
            };

            const _buildDeleteModal = (scheduleId) => {
                const displayType = _commonState.typeDisplay.schedule;
                let constructorParams = [scheduleId];
                self.actionModal
                    .clearModal()
                    .setContentViewModel(DeleteActionViewModelConstructor, constructorParams)
                    .setHeaderText({i18n: {key: 'deleteHeader', options: {type: displayType}}})
                    .setSubmitButtonText({i18n: 'delete'});
            };

            const _buildIntegrityWarningsModal = (scheduleId) => {
                const displayType = _commonState.typeDisplay.schedule;
                self.integrityWarningModal
                    .clearModal()
                    .setHeading({key: 'delete', options: {type: displayType}})
                    .addText({i18n: {key: 'inUse', options: {type: displayType.toLowerCase()}}})
                    .setSystemObject({objectId: scheduleId})
                    .addIntegrityWarningText({i18n: {key: 'conflicts'}});
            };

            const _showDeletePrompt = () => {
                const schedule = self.receptionistSchedule();
                const scheduleId = schedule.accountAttendantScheduleId;
                const liveReceptionistScriptId = schedule.liveReceptionistScriptId;
                _buildDeleteModal(scheduleId);
                self.actionModal.showModal()
                    .done((result) => {
                        if (result === _deleteResponse) {
                            _facade.deleteSchedule(scheduleId, liveReceptionistScriptId)
                                .done(() => {
                                    self.receptionistSchedule(null);
                                })
                                .fail((error) => {
                                    if (error.constraintViolations && error.constraintViolations.length > 0) {
                                        _showIntegrityWarningsPrompt(scheduleId, error.constraintViolations);
                                    } else {
                                        error.accountAttendantScheduleId = scheduleId;
                                        throw error;
                                    }
                                });
                        }
                    });
            };

            self.liveReceptionistScriptId = null;
            self.receptionistSchedule = ko.observable(null);
            self.showNoTransferScheduleMessage = ko.pureComputed(() => self.receptionistSchedule() === null);
            self.addScheduleUrl = ko.observable('');
            self.createTransferScheduleLink = _i18n.t('addLiveReceptionistScript:createTransferSchedule');
            self.noTransferScheduleWarningMessage = _i18n.t('addLiveReceptionistScript:noTransferScheduleFound');
            self.scheduleMapDayLabels = _scheduleCommonFunctions.scheduleMapDayLabels;
            self.scheduleMapTimeLabels = _scheduleCommonFunctions.scheduleMapTimeLabels;
            self.actionModal = new ActionModalViewModelConstructor();
            self.integrityWarningModal = new IntegrityWarningModalViewModelConstructor();
            self.isCompositionComplete = ko.observable(false);

            self.isImpersonating = ko.pureComputed(() => {
                return _sessionAccountInfo.isImpersonating();
            });

            self.navigateToEditSchedule = () => {
                if (self.isImpersonating()){
                    _router.navigate(self.receptionistSchedule().editScheduleUrl);
                }
            };

            self.launchDeleteSchedule = () => {
                const scheduleId = self.receptionistSchedule().accountAttendantScheduleId;
                return _promiseFactory.deferIndefinitely((promise) => {
                   if (!self.isImpersonating()){
                       promise.resolve();
                       return;
                   }
                    _facade.getConstraints(scheduleId)
                        .done((integrityWarningPresentationObjects) => {
                            if (integrityWarningPresentationObjects.length > 0) {
                                _showIntegrityWarningsPrompt(scheduleId, integrityWarningPresentationObjects);
                            } else {
                                _showDeletePrompt();
                            }
                            promise.resolve();
                        });
                });
            };

            self.detached = () => {
                self.isCompositionComplete(false);
            };

            self.compositionComplete = () => {
                self.isCompositionComplete(true);
            };

            self.activate = (liveReceptionistScriptId, receptionistSchedule) => {
               self.addScheduleUrl(_navigationConfiguration.routesById.editSchedule.baseUrl + "transferSchedule" + "/" + liveReceptionistScriptId);

                if (receptionistSchedule !== null) {
                    self.receptionistSchedule(Object.assign({}, receptionistSchedule, {
                        sundayGridCells: _emptyGridCellsForDay(),
                        mondayGridCells: _emptyGridCellsForDay(),
                        tuesdayGridCells: _emptyGridCellsForDay(),
                        wednesdayGridCells: _emptyGridCellsForDay(),
                        thursdayGridCells: _emptyGridCellsForDay(),
                        fridayGridCells: _emptyGridCellsForDay(),
                        saturdayGridCells: _emptyGridCellsForDay(),
                        segments: ko.pureComputed(() => {
                            return receptionistSchedule.segments.sort((a, b) => a.sequence() - b.sequence());
                        }),
                        get setGridRanges() {
                            return ko.computed(() => _setScheduleGridRanges(this, this.segments()));
                        }
                    }));
                }

                const FacadeConstructor = require('presentation/settings/liveReceptionistScripts/facades/liveReceptionistScriptFindMeTabFacade');
                _facade = new FacadeConstructor();
                _facade.init(_promiseFactory);

                return _initialize();
            };

            const _initialize = () => {
                return _promiseFactory.defer((initPromise) => {
                    initPromise.resolve();
                });
            };
        };
    });

